import * as actions from '../actions/balances'
import Immutable from 'seamless-immutable'

const initialState = Immutable({
	available : NaN,
	savings : NaN,
	account : NaN,

	amountWithdrawnToday: NaN,

	savingStreams: []
})

export default function (state = initialState, action){

	switch(action.type){

		case actions.RECEIVE_BALANCES:
			return state
				.set('available', action.available)
				.set('savings', action.savings)
				.set('account', action.account)

		case actions.RECEIVE_SAVINGS:
			return state
				.set('savingStreams', action.streams)

		case actions.RECEIVE_WITHDRAWN_BALANCES:
			return state
				.set('amountWithdrawnToday', action.amountWithdrawnToday)
	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/balances.js